import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=269a538b&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269a538b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('269a538b')) {
      api.createRecord('269a538b', component.options)
    } else {
      api.reload('269a538b', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=269a538b&scoped=true&", function () {
      api.rerender('269a538b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ydrpk9orsoMV/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports